// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter_wrapper__QAigk {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 1001; }

.filter_content__k0JF9 {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 450px;
  background-color: var(--White);
  display: flex;
  flex-direction: column;
  justify-content: space-between; }

.filter_settings__4D7lQ {
  display: flex;
  flex-direction: column;
  overflow: scroll;
  gap: 30px;
  padding: 20px 10px 0 10px; }

.filter_header__4BTKy {
  display: flex;
  justify-content: space-between; }
  .filter_header_title__\\+KysN {
    font-weight: 600;
    font-size: 24px;
    line-height: 150%;
    color: var(--HightEmphasis); }
  .filter_header_cross__d\\+o5V {
    width: 30px;
    height: 30px;
    padding: 6px;
    font-weight: 600;
    font-size: 24px;
    line-height: 150%;
    color: var(--HightEmphasis);
    position: relative;
    cursor: pointer; }

.filter_scrollarea__qSR2a {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 100vh; }

.filter_block__Cs6Vv {
  color: var(--HightEmphasis); }
  .filter_block_title__vnXiP {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 10px; }
  .filter_block_text__c4Gk0 {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px; }
  .filter_block_content__yn1wq {
    display: flex;
    flex-wrap: wrap; }

.filter_checkbox__Il7tS {
  width: 100%;
  max-width: 170px; }
  .filter_checkbox__Il7tS label {
    max-width: 170px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap; }

.filter_footer__eQwNl {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-top: 1px solid var(--Gray88); }
  .filter_footer_text__nf1HU {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: var(--HightEmphasis);
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px; }
  .filter_footer_buttons__rYrOG {
    display: flex;
    gap: 20px; }
`, "",{"version":3,"sources":["webpack://./src/pages/previewOrders/components/FilterBar/filter.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAA;;AAGhC;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,yBAAyB,EAAA;;AAG3B;EACE,aAAa;EACb,8BAA8B,EAAA;EAC9B;IC7BA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;ID6Bf,2BAA2B,EAAA;EAE7B;IACE,WAAW;IACX,YAAY;IACZ,YAAY;ICpCd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDoCf,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe,EAAA;;AAInB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa,EAAA;;AAGf;EACE,2BAA2B,EAAA;EAC3B;IC/CA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;ID+Cf,mBAAmB,EAAA;EAErB;ICrBA,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EDsBjB;IACE,aAAa;IACb,eAAe,EAAA;;AAInB;EACE,WAAW;EACX,gBAAgB,EAAA;EAFlB;IAKI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mCAAmC,EAAA;EACnC;ICXA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDWf,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EAEnB;IACE,aAAa;IACb,SAAS,EAAA","sourcesContent":["@import 'src/styles/media.scss';\n@import 'src/styles/fonts.scss';\n\n.wrapper {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: flex-end;\n  transition: all 0.3s ease-in-out;\n  overflow: hidden;\n  z-index: 1001;\n}\n\n.content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  max-width: 450px;\n  background-color: var(--White);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.settings {\n  display: flex;\n  flex-direction: column;\n  overflow: scroll;\n  gap: 30px;\n  padding: 20px 10px 0 10px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  &_title {\n    @include h2;\n    color: var(--HightEmphasis);\n  }\n  &_cross {\n    width: 30px;\n    height: 30px;\n    padding: 6px;\n    @include h2;\n    color: var(--HightEmphasis);\n    position: relative;\n    cursor: pointer;\n  }\n}\n\n.scrollarea {\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  height: 100vh;\n}\n\n.block {\n  color: var(--HightEmphasis);\n  &_title {\n    @include h3;\n    margin-bottom: 10px;\n  }\n  &_text {\n    @include body2;\n  }\n  &_content {\n    display: flex;\n    flex-wrap: wrap;\n  }\n}\n\n.checkbox {\n  width: 100%;\n  max-width: 170px;\n\n  & label {\n    max-width: 170px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n}\n\n.footer {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n  border-top: 1px solid var(--Gray88);\n  &_text {\n    @include button;\n    color: var(--HightEmphasis);\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 24px;\n  }\n  &_buttons {\n    display: flex;\n    gap: 20px;\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `filter_wrapper__QAigk`,
	"content": `filter_content__k0JF9`,
	"settings": `filter_settings__4D7lQ`,
	"header": `filter_header__4BTKy`,
	"header_title": `filter_header_title__+KysN`,
	"header_cross": `filter_header_cross__d+o5V`,
	"scrollarea": `filter_scrollarea__qSR2a`,
	"block": `filter_block__Cs6Vv`,
	"block_title": `filter_block_title__vnXiP`,
	"block_text": `filter_block_text__c4Gk0`,
	"block_content": `filter_block_content__yn1wq`,
	"checkbox": `filter_checkbox__Il7tS`,
	"footer": `filter_footer__eQwNl`,
	"footer_text": `filter_footer_text__nf1HU`,
	"footer_buttons": `filter_footer_buttons__rYrOG`
};
export default ___CSS_LOADER_EXPORT___;
